import { FileText, Inbox, LucideIcon, Settings } from "lucide-react";

import { NotificationCategory } from "@interfaces/notification";

const CATEGORY_ICONS: Record<NotificationCategory, LucideIcon> = {
    pipeline: Inbox,
    document: FileText,
    system: Settings,
};

/**
 * Mapea primero por `type_code`, y cae a `category` como respaldo, para que
 * un tipo nuevo del backend siempre tenga un ícono razonable sin desplegar
 * el front.
 */
const TYPE_ICONS: Record<string, LucideIcon> = {};

export function iconFor(typeCode: string, category: NotificationCategory): LucideIcon {
    return TYPE_ICONS[typeCode] ?? CATEGORY_ICONS[category] ?? Inbox;
}
